import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DynamicScriptLoaderService {
  loadScript(url: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.type = 'text/javascript';
      script.onload = () => {
        resolve();
      };
      script.onerror = () => {
        const error = new Error(`Failed to load script at ${ url }`);
        reject(error);
      };
      document.head.appendChild(script);
    });
  }
}
